// src/routes/AdminRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function AdminRoute({ children, allowedRoles = [] }) {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));

  // Not logged in
  if (!user) {
    // Keep the full target (path and query) so Login can send the user back to it
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  // Always allow superadmin access
  if (user.role === 'superadmin') {
    return children;
  }

  // Members reach admin pages only as delegates of at least one group (the server re-checks this)
  if (user.role === 'member') {
    if (allowedRoles.includes('member') && user.delegatedGroupCount > 0) return children;
    return <Navigate to="/unauthorized" replace />;
  }

  // Otherwise, check allowed roles
  const hasAccess = allowedRoles.includes(user.role);
  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
